// Confirmaciones y avisos con el estilo de la app, en lugar de confirm()/alert() del navegador.
//
//   if (!(await this.$confirmar({ titulo: "Eliminar adjunto", texto: "...", peligro: true }))) return;
//   this.$avisar("No se pudo guardar", "error");
//
// Los muestra el componente <DialogosGlobales> (montado una vez en App.vue).
import Vue from "vue";

export const estadoDialogos = Vue.observable({
  confirmacion: null, // { titulo, texto, aceptar, cancelar, peligro, icono, resolver }
  aviso: null, // { texto, tipo, id }
});

/** Pide confirmación; devuelve una promesa que se resuelve a true (aceptar) o false */
export function confirmar(opciones) {
  const o = typeof opciones === "string" ? { texto: opciones } : opciones || {};
  // si ya había una abierta, se da por cancelada
  if (estadoDialogos.confirmacion) estadoDialogos.confirmacion.resolver(false);
  return new Promise((resolver) => {
    estadoDialogos.confirmacion = {
      titulo: o.titulo || "Confirmar",
      texto: o.texto || "",
      aceptar: o.aceptar || (o.peligro ? "Eliminar" : "Aceptar"),
      cancelar: o.cancelar || "Cancelar",
      peligro: !!o.peligro,
      icono: o.icono || (o.peligro ? "mdi-alert-circle-outline" : "mdi-help-circle-outline"),
      resolver,
    };
  });
}

/** Aviso breve en la parte superior (tipo: info | success | error | warning) */
export function avisar(texto, tipo = "info") {
  estadoDialogos.aviso = { texto, tipo, id: Date.now() };
}

export default {
  install(VueClass) {
    VueClass.prototype.$confirmar = confirmar;
    VueClass.prototype.$avisar = avisar;
  },
};
